import { useState, useCallback, useRef, useEffect } from "react";

interface PlayOptions {
  onFinish?: Function;
  onError?: Function;
}

const useAudioPlayer = () => {
  const [currentUrl, setCurrentUrl] = useState<string>("");

  const audioRef = useRef<HTMLAudioElement>(new Audio());
  const optionsRef = useRef<PlayOptions | null>(null);

  useEffect(() => {
    const audio = audioRef.current;

    audio.onended = () => {
      optionsRef.current?.onFinish?.();
    };
    audio.onerror = (error) => {
      optionsRef.current?.onError?.(error);
    };

    return () => {
      console.log("clean up event listenrs");
      audio.onended = null;
      audio.onerror = null;
    };
  }, []);

  const playAudio = useCallback(
    (audioUrl: string, voiceOn: boolean, options?: PlayOptions) => {
      if (!audioRef.current) return;

      const audio = audioRef.current;

      optionsRef.current = options || null;
      audio.muted = !voiceOn;

      if (audio.src !== audioUrl) {
        audio.src = audioUrl;
        audio.currentTime = 0;
        setCurrentUrl(audioUrl);
      } else if (!audio.paused) {
        audio.currentTime = 0;
      }
      console.log("play audio start")
      audio.play().catch((error) => {
        console.error("Failed to play audio:", error);
        options?.onError?.(error);
      });
    },
    [currentUrl]
  );

  const pauseAudio = useCallback(() => {
    console.log("pause audio")
    audioRef.current?.pause();
  }, []);

  const resumeAudio = useCallback(() => {
    console.log("resumeAudio")
    audioRef.current.play().catch((error) => {
      console.error("Failed to resume audio:", error);
      optionsRef.current?.onError?.(error);
    });
  }, []);

  const muteAudio = useCallback(() => {
    if (!audioRef.current) return;

    audioRef.current.muted = true;
  }, []);

  // Unmute audio
  const unmuteAudio = useCallback(() => {
    if (!audioRef.current) return;

    audioRef.current.muted = false;
  }, []);

  // Stop and reset
  const stopAudio = useCallback(() => {
    if (!audioRef.current) return;
    console.log("stopAudio")
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    audioRef.current.src = "";
  }, []);

  return {
    currentUrl,
    playAudio,
    pauseAudio,
    resumeAudio,
    stopAudio,
    muteAudio,
    unmuteAudio,
  };
};

export default useAudioPlayer;
